export default "__VITE_ASSET__IUjUG73A__"